export default __webpack_public_path__ + "static/media/earth.09e53b6e.jpg";